import { useEnum } from "@/api/services/global/enum";
import { InnerBox } from "@/components/elements/InnerBox";
import { EMPTY_STR } from "@/constants/string";
import { TalentInfoItem } from "@/features/talent/components/talent-detail/TalentInfoItem";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { findLabelByValue } from "@/utils/object";
import { Stack, Box, Typography, Grid } from "@mui/material";

type TTalentEducationBackgroundProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentEducationBackground: FCC<TTalentEducationBackgroundProps> = ({ defaultValues }) => {
  const { data: educationLevelOptions } = useEnum("EEducationLevel");
  const { data: foreignLanguageOptions } = useEnum("EForeignLanguage");

  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            学歴・保有資格・語学
          </Typography>
        </Box>
      </Stack>
      <Stack mt={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack mb={1}>
              <Typography variant="cap12" color={black[70]}>
                学歴
              </Typography>
            </Stack>
            {defaultValues?.educationBackground?.length ? (
              defaultValues?.educationBackground?.map((item, index) => (
                <TalentInfoItem
                  value={findLabelByValue(educationLevelOptions, item)}
                  isShowDivider={(defaultValues.educationBackground?.length ?? 0) - 1 === index}
                />
              ))
            ) : (
              <TalentInfoItem value={EMPTY_STR.TEXT} />
            )}
          </Grid>
        </Grid>
      </Stack>
      <Stack mt={1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack mb={1}>
              <Typography variant="cap12" color={black[70]}>
                資格
              </Typography>
            </Stack>
            {defaultValues?.heldQualifications?.length ? (
              defaultValues?.heldQualifications?.map((item, index) => (
                <TalentInfoItem value={item ?? EMPTY_STR.TEXT} isShowDivider={(defaultValues.heldQualifications?.length ?? 0) - 1 === index} />
              ))
            ) : (
              <TalentInfoItem value={EMPTY_STR.TEXT} />
            )}
          </Grid>
        </Grid>
      </Stack>
      {defaultValues?.languageSkills?.length ? (
        defaultValues?.languageSkills?.map((item, index) => (
          <InnerBox mt={index != 0 ? 2 : 1} showDivider={false} p={2}>
            <Grid container>
              <Grid item xs={12}>
                <Stack mb={1}>
                  <Typography variant="cap12" color={black[70]}>
                    語学（日本語以外の言語）
                  </Typography>
                </Stack>
                <TalentInfoItem
                  value={item?.language ? findLabelByValue(foreignLanguageOptions, item?.language) : EMPTY_STR.TEXT}
                  isShowDivider={false}
                />
              </Grid>
              <Grid item xs={12}>
                <Stack mb={1} mt={2}>
                  <Typography variant="cap12" color={black[70]}>
                    語学（日本語以外の言語）の内容
                  </Typography>
                </Stack>
                <TalentInfoItem value={item?.content ?? EMPTY_STR.TEXT} isShowDivider={false} />
              </Grid>
            </Grid>
          </InnerBox>
        ))
      ) : (
        <InnerBox mt={2} showDivider={false} p={2}>
          <Grid container>
            <Grid item xs={12}>
              <Stack mb={1}>
                <Typography variant="cap12" color={black[70]}>
                  語学（日本語以外の言語）
                </Typography>
              </Stack>
              <TalentInfoItem value={EMPTY_STR.TEXT} isShowDivider={false} />
            </Grid>
            <Grid item xs={12}>
              <Stack mb={1} mt={2}>
                <Typography variant="cap12" color={black[70]}>
                  語学（日本語以外の言語）の内容
                </Typography>
              </Stack>
              <TalentInfoItem value={EMPTY_STR.TEXT} isShowDivider={false} />
            </Grid>
          </Grid>
        </InnerBox>
      )}
    </InnerBox>
  );
};
